<template>
   <breadCrumbs title="Modal" main="UI Kits" title1="Modal" /> 
   <div class="container-fluid">
            <div class="row">
               <staicModal/>
               <basicModal/>
               <varyingModal/>
               <sizesModal/>
            </div>
 </div>
</template>
<script>
import basicModal from "./basicModal.vue"
import varyingModal from "./varyingModal.vue"
import sizesModal from "./sizesModal.vue"
import staicModal from "./staicModal.vue"
export default {
   components:{
       basicModal,
       varyingModal,
       sizesModal,staicModal
   }
}
</script>